// extracted by mini-css-extract-plugin
export var gif = "_ik-0";